import { CircularProgress } from '@mui/material'
import PropTypes from 'prop-types'

/**
 * Renders a loader component using CircularProgress from @mui/material.
 *
 * @author Maria Eduarda Franke
 * @param {string} color - The color of the loader.
 * @returns {JSX.Element} - The loader component.
 */
const Loader = ({ color, ...props }) => {
    return (
        <CircularProgress color={color} {...props} />
    )
}

Loader.propTypes = {
    color: PropTypes.oneOf(['primary', 'secondary', 'warning', 'error', 'info', 'success']).isRequired
}

export default Loader
